import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Container, Span } from 'components/Ui';
import { accountIcons } from 'images/index';
import Loader from 'components/Loader';
import { createStructuredSelector } from 'reselect';
import {
  selectDeliveryAfterSkip,
  selectNextDelivery,
  selectServiceLocationIsSkipProcessing,
  selectIsFetchingCalendarDates,
  selectDeliveryIsFetching,
} from 'containers/PrimoAccount/selectors';
import {
  skipDelivery as skipDeliveryRequest,
  getDeliveryAfterSkip as getDeliveryAfterSkipRequest,
  getServiceLocationNextDelivery as getServiceLocationNextDeliveryRequest,
} from 'containers/PrimoAccount/actions';
import moment from 'moment';
import { dataLayerPush } from 'utils/tracking';
import styles from './styles.scss';

const formatDate = (date) => moment(date).format('MMM Do YYYY');
const formatDateForDataLayer = (date) => moment(date).format('YYYY-MM-DD');

class SkipDelivery extends React.PureComponent {
  componentDidMount() {
    if (!this.props.deliveryAfterSkip) {
      this.props.getServiceLocationNextDelivery();
    }
    this.props.getDeliveryAfterSkip();
  }

  handleConfirm = () => {
    const { skipDelivery, nextDelivery } = this.props;
    skipDelivery(nextDelivery);
    const date = formatDateForDataLayer(this.props.nextDelivery.date);
    dataLayerPush(
      'SelfServe',
      {
        event: 'skip-delivery-confirm',
        date,
      },
      'dlS26',
    );
  };

  handleCancel = () => {
    this.props.onClose();
    const date = formatDateForDataLayer(this.props.nextDelivery.date);
    dataLayerPush(
      'SelfServe',
      {
        event: 'skip-delivery-cancel',
        date,
      },
      'dlS27',
    );
  };

  render() {
    const {
      isSkipProcessing,
      deliveryAfterSkip,
      isFetchingDates,
      isFetchingDelivery,
    } = this.props;

    return (
      <Container value="Ship this delivery modal">
        <div className={styles.content}>
          <img src={accountIcons.SkipIcon} alt="skip icon" />
          <Span className={styles.title}>Skip this delivery</Span>
          <Span className={styles.text}>
            Your future deliveries will continue according to their regular
            schedule after this one is skipped.{' '}
          </Span>
          <Loader loading={isFetchingDates || isFetchingDelivery} local>
            {deliveryAfterSkip && (
              <Fragment>
                <Span className={styles.subtitle}>
                  Your next delivery will be:
                </Span>
                <div className={styles.dateContainer}>
                  {formatDate(deliveryAfterSkip.date)}
                </div>
              </Fragment>
            )}
          </Loader>
        </div>
        <div className={styles.bottom}>
          <Button
            text="Cancel"
            color="gray"
            ariaLabel="cancel dialog"
            className={styles.cancel}
            onClick={this.handleCancel}
            disabled={isSkipProcessing}
          />
          <Button
            text="Confirm"
            ariaLabel="confirm skip delivery"
            onClick={this.handleConfirm}
            loading={isSkipProcessing}
          />
        </div>
      </Container>
    );
  }
}

SkipDelivery.propTypes = {
  onClose: PropTypes.func.isRequired,
  skipDelivery: PropTypes.func.isRequired,
  getServiceLocationNextDelivery: PropTypes.func.isRequired,
  deliveryAfterSkip: PropTypes.object,
  nextDelivery: PropTypes.object,
  isSkipProcessing: PropTypes.bool,
  isFetchingDates: PropTypes.bool,
  isFetchingDelivery: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  deliveryAfterSkip: selectDeliveryAfterSkip(),
  isSkipProcessing: selectServiceLocationIsSkipProcessing(),
  nextDelivery: selectNextDelivery(),
  isFetchingDates: selectIsFetchingCalendarDates(),
  isFetchingDelivery: selectDeliveryIsFetching(),
});

const mapDispatchToProps = {
  skipDelivery: skipDeliveryRequest,
  getDeliveryAfterSkip: getDeliveryAfterSkipRequest,
  getServiceLocationNextDelivery: getServiceLocationNextDeliveryRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(SkipDelivery);
